module.exports = __webpack_public_path__ + "img/Antonia&Stephan-13.cdfd7b5f.jpg";